import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'

const WithIntl = Component => props => {
  // logUtil('WithIntl').debug('props=', props)
  const intl = useIntl()
  return (
    <Component
      {...props}
      intl={intl}
    />
  )
}

export default WithIntl
